'use client';

import { useLocalTranslation } from '../hooks/useLocalTranslation';
import translations from './BlockedScreen.translations';

export function BlockedScreen() {
  const { t } = useLocalTranslation(translations);
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ background: 'var(--tg-theme-bg-color, #1a1a1a)' }}
    >
      <div className="text-center max-w-xs px-6" style={{ color: 'var(--tg-theme-text-color, #fff)' }}>
        <div className="text-6xl mb-6">🚫</div>
        <h1 className="text-2xl font-semibold m-0">{t('title')}</h1>
        <p className="mt-3 text-sm opacity-70 leading-snug">{t('description')}</p>
      </div>
    </div>
  );
}
